module.exports = __webpack_public_path__ + "img/kf1.bf1f39c2.png";